import { registerSW } from 'virtual:pwa-register';

let activateUpdate: ((reloadPage?: boolean) => Promise<void>) | undefined;

export function registerAppServiceWorker() {
  activateUpdate = registerSW({
    immediate: true,
    onNeedRefresh() {
      window.dispatchEvent(new Event('nutians:pwa-update-available'));
    },
    onRegisterError(error) {
      console.warn('Service worker registration failed', error);
    },
  });
}

export async function activateWaitingServiceWorker() {
  await activateUpdate?.(true);
}
